
import { defineComponent, ref, watch } from "vue";
import axios from "@/axios-instance"
import { hideModal } from "@/core/helpers/dom";
export default defineComponent({
  name: "modalDeleteAndReason",
  emits:["callBackFunc"],
  props: {
    ids: Array,
    id: String,
    title: String,
    label: String,
    dataCustomer: Object as any,
  },
  methods: {
    showModal() {
        this.call_modal_crm.click()
    },
    closeModal(){
        this.comment_profile = ''
        hideModal(this.editFieldModalRef)
    },
    async submitComment() {
      if (this.comment_profile == '') {
        return;
      }

      this.$emit("callBackFunc",{field: this.label, value: this.comment_profile})
      this.comment_profile = ''
      hideModal(this.editFieldModalRef)
    },
    onModalShown() {
      if(this.label && this.dataCustomer) {
        this.comment_profile = this.dataCustomer[this.label]
      }
      else {
        this.comment_profile = ''
      }
    }
  },
  
  mounted() {
    if (this.editFieldModalRef) {
      this.editFieldModalRef.addEventListener('shown.bs.modal', this.onModalShown)
    }
    
  },
  beforeUnmount() {
    if (this.editFieldModalRef) {
      this.editFieldModalRef.removeEventListener('shown.bs.modal', this.onModalShown)
    }
  },
  
  setup() {
    
    const editFieldModalRef = ref<null | HTMLElement>(null);
    const call_modal_crm = ref<any>();
    const comment_profile = ref('')
    function user() {
      let temp  = window.localStorage.getItem("user")
      return temp?JSON.parse(temp) : null
    }
    return {
        call_modal_crm,
        editFieldModalRef,
        comment_profile,
        user
    };
  },
});
